/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "cmsdatapull",
            "endpoint": "https://vldrhl3k37.execute-api.us-west-2.amazonaws.com/tools",
            "region": "us-west-2"
        },
        {
            "name": "investorReport",
            "endpoint": "https://ack7pdq212.execute-api.us-west-2.amazonaws.com/tools",
            "region": "us-west-2"
        },
        {
            "name": "repricing",
            "endpoint": "https://i1b3v4tbl4.execute-api.us-west-2.amazonaws.com/tools",
            "region": "us-west-2"
        },
        {
            "name": "titlesearch",
            "endpoint": "https://u0ymr8h7kb.execute-api.us-west-2.amazonaws.com/tools",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:36563fbb-b067-4d53-a876-3e07de0ac738",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_OsVBHGafe",
    "aws_user_pools_web_client_id": "e8a3io25l4iina8nbeo9579qj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
